import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { RiMessage2Line } from '../../../assets/icons/vander';
import ChatBotLogo from '../../../assets/images/svg/chat-bot-logo.svg';
import { closeAllAnamSessions } from '../../services';

export const ChatModeSelection = ({ show, onSelect, onClose }) => {
  const [isClosing, setIsClosing] = useState(false);

  const handleCloseAllSessions = async () => {
    setIsClosing(true);
    try {
      await closeAllAnamSessions();
      console.log('[ChatModeSelection] All ANAM sessions closed');
    } catch (error) {
      console.error('[ChatModeSelection] Error closing ANAM sessions:', error);
    } finally {
      setIsClosing(false);
    }
  };
  return (
    <Modal show={show} onHide={onClose} centered className="chat-mode-selection-modal">
      <Modal.Body className="p-4">
        <div className="text-center mb-4">
          <h4 className="mb-2">Elige cómo quieres responder</h4>
          <p className="text-muted mb-0">
            Selecciona el método que prefieras para completar la encuesta
          </p>
        </div>

        <div className="d-flex flex-column gap-3">
          <button
            type="button"
            className="btn btn-outline-primary p-4 d-flex align-items-center gap-3 text-start"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (onSelect) {
                onSelect('chatbot');
              }
            }}
            style={{ borderRadius: '12px' }}
          >
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                width: '56px',
                height: '56px',
                borderRadius: '12px',
                backgroundColor: 'rgba(13, 110, 253, 0.1)',
              }}
            >
              <RiMessage2Line style={{ fontSize: '28px', color: '#0d6efd' }} />
            </div>
            <div className="flex-grow-1">
              <h5 className="mb-1">Chatbot</h5>
              <p className="mb-0 text-muted small">
                Conversación por texto o voz con nuestro asistente virtual
              </p>
            </div>
            <div className="text-primary">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </div>
          </button>

          <button
            type="button"
            className="btn btn-outline-primary p-4 d-flex align-items-center gap-3 text-start"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              console.log('[ChatModeSelection] Avatar ANAM AI clicked');
              if (onSelect) {
                onSelect('anam');
              } else {
                console.error('[ChatModeSelection] onSelect is not defined');
              }
            }}
            style={{ borderRadius: '12px' }}
          >
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                width: '56px',
                height: '56px',
                borderRadius: '12px',
                backgroundColor: 'rgba(13, 110, 253, 0.1)',
              }}
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#0d6efd"
                strokeWidth="2"
              >
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z" />
              </svg>
            </div>
            <div className="flex-grow-1">
              <h5 className="mb-1">Avatar ANAM AI</h5>
              <p className="mb-0 text-muted small">
                Interacción por voz con un avatar virtual que te guiará paso a paso
              </p>
            </div>
            <div className="text-primary">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </div>
          </button>
        </div>

        <button
          type="button"
          className="btn btn-outline-danger w-100 mt-3"
          onClick={handleCloseAllSessions}
          disabled={isClosing}
        >
          {isClosing ? 'Cerrando sesiones...' : 'Cerrar todas las sesiones ANAM'}
        </button>

        <button
          className="btn btn-link text-muted w-100 mt-2"
          onClick={onClose}
        >
          Cancelar
        </button>
      </Modal.Body>
    </Modal>
  );
};

